// extracted by mini-css-extract-plugin
module.exports = {"dividers":"web-footer-content_dividers__zRs41"};